import { cardeal } from './api';

export class PatrocinadoraService {
  getPatrocinadoraParticipante = async (matricula) => {
    const response = await cardeal.get('ObterPatrocinadoraParticipante', {
      params: {
        matricula,
      },
    });
    return response.data.ObterPatrocinadoraParticipanteResult;
  };
}
